(function () {
  window.RotaTheme?.register('home-hero', {
    init(hero) {
      const slides = Array.from(hero.querySelectorAll('[data-rm-hero-slide]')).map((slide) => ({
        blockId: slide.dataset.rmHeroBlockId || '',
        image: slide.dataset.image || '',
        eyebrow: slide.dataset.eyebrow || '',
        title: slide.dataset.title || '',
        text: slide.dataset.text || '',
        buttonLink: slide.dataset.buttonLink || '',
      }));
      const image = hero.querySelector('[data-rm-hero-image], .rm-hero__image');
      const eyebrow = hero.querySelector('[data-rm-hero-eyebrow]');
      const title = hero.querySelector('[data-rm-hero-title]');
      const text = hero.querySelector('[data-rm-hero-text]');
      const cta = hero.querySelector('[data-rm-hero-cta]');
      const previous = hero.querySelector('[data-rm-hero-prev]');
      const next = hero.querySelector('[data-rm-hero-next]');
      const dots = Array.from(hero.querySelectorAll('[data-rm-hero-dot]'));
      if (slides.length < 2 || !image || !title || !text || !previous || !next) return null;

      let activeIndex = 0;
      const show = (index) => {
        activeIndex = (index + slides.length) % slides.length;
        const slide = slides[activeIndex];
        hero.dataset.rmActiveSlide = String(activeIndex);
        if (slide.image) {
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.setAttribute('src', slide.image);
        }
        if (eyebrow) eyebrow.textContent = slide.eyebrow;
        title.textContent = slide.title;
        text.textContent = slide.text;
        if (cta && slide.buttonLink) cta.setAttribute('href', slide.buttonLink);
        dots.forEach((dot, dotIndex) => dot.setAttribute('aria-pressed', String(dotIndex === activeIndex)));
      };
      const prevHandler = () => show(activeIndex - 1);
      const nextHandler = () => show(activeIndex + 1);
      const dotHandlers = dots.map((dot, index) => {
        const handler = () => show(index);
        dot.addEventListener('click', handler);
        return [dot, handler];
      });
      const keyHandler = (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        show(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
      };
      const blockSelectHandler = (event) => {
        const index = slides.findIndex((slide) => slide.blockId === event.detail?.blockId);
        if (index !== -1) show(index);
      };

      previous.addEventListener('click', prevHandler);
      next.addEventListener('click', nextHandler);
      hero.addEventListener('keydown', keyHandler);
      hero.addEventListener('rm:block:select', blockSelectHandler);
      show(activeIndex);

      return () => {
        previous.removeEventListener('click', prevHandler);
        next.removeEventListener('click', nextHandler);
        hero.removeEventListener('keydown', keyHandler);
        hero.removeEventListener('rm:block:select', blockSelectHandler);
        dotHandlers.forEach(([dot, handler]) => dot.removeEventListener('click', handler));
      };
    },
  });

  window.RotaTheme?.register('featured-collections-tabs', {
    init(collection) {
      const tabs = Array.from(collection.querySelectorAll('[role="tab"]'));
      const panels = Array.from(collection.querySelectorAll('[role="tabpanel"]'));
      const image = collection.querySelector('[data-rm-featured-image], .rm-featured-collection__image');
      const imageLink = collection.querySelector('[data-rm-featured-media-link]');
      if (!tabs.length || tabs.length !== panels.length) return null;

      const getPanelImage = (panel) => panel.dataset.rmFeaturedImageSrc || panel.querySelector('.rm-featured-collection__thumb-image')?.getAttribute('src');
      const activate = (nextTab, shouldFocus = true) => {
        const activeIndex = tabs.indexOf(nextTab);
        tabs.forEach((tab, index) => {
          const isActive = tab === nextTab;
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
          panels[index].hidden = !isActive;
        });
        const nextImage = getPanelImage(panels[activeIndex]);
        if (image && nextImage && image.getAttribute('src') !== nextImage) {
          image.dataset.rmFeaturedImageChanging = 'true';
          window.setTimeout(() => {
            image.setAttribute('src', nextImage);
            image.removeAttribute('srcset');
            image.removeAttribute('sizes');
            image.removeAttribute('data-rm-featured-image-changing');
          }, 80);
        }
        if (imageLink && panels[activeIndex]?.dataset.rmFeaturedLink) {
          imageLink.setAttribute('href', panels[activeIndex].dataset.rmFeaturedLink);
          imageLink.setAttribute('aria-label', nextTab.textContent.trim());
        }
        if (shouldFocus) nextTab.focus({ preventScroll: true });
      };
      const cleanups = [];
      tabs.forEach((tab, index) => {
        const clickHandler = () => activate(tab);
        const keyHandler = (event) => {
          const keyActions = {
            ArrowRight: () => tabs[(index + 1) % tabs.length],
            ArrowLeft: () => tabs[(index - 1 + tabs.length) % tabs.length],
            Home: () => tabs[0],
            End: () => tabs[tabs.length - 1],
          };
          if (event.key === ' ' || event.key === 'Enter') {
            event.preventDefault();
            activate(tab);
            return;
          }
          const nextTab = keyActions[event.key]?.();
          if (!nextTab) return;
          event.preventDefault();
          activate(nextTab);
        };
        tab.addEventListener('click', clickHandler);
        tab.addEventListener('keydown', keyHandler);
        cleanups.push(() => tab.removeEventListener('click', clickHandler));
        cleanups.push(() => tab.removeEventListener('keydown', keyHandler));
      });
      const blockSelectHandler = (event) => {
        const block = event.target.closest('.shopify-block') || event.target;
        const selectedTab = tabs.find((tab) => tab.contains(block) || tab.getAttribute('data-block-id') === event.detail?.blockId);
        if (selectedTab) activate(selectedTab, false);
      };
      collection.addEventListener('rm:block:select', blockSelectHandler);
      cleanups.push(() => collection.removeEventListener('rm:block:select', blockSelectHandler));
      collection.dataset.rmFeaturedEnhanced = 'true';
      activate(tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0], false);
      return () => cleanups.forEach((cleanup) => cleanup());
    },
  });

  window.RotaTheme?.register('testimonials', {
    init(testimonial) {
      const slides = Array.from(testimonial.querySelectorAll('[data-rm-testimonial-slide]'));
      const previous = testimonial.querySelector('[data-rm-testimonial-prev]');
      const next = testimonial.querySelector('[data-rm-testimonial-next]');
      if (slides.length < 2 || !previous || !next) return null;
      let activeIndex = Math.max(0, slides.findIndex((slide) => !slide.hidden));
      let isAnimating = false;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const setVisibleSlide = (index) => {
        slides.forEach((slide, slideIndex) => {
          slide.hidden = slideIndex !== index;
          slide.classList.remove('rm-testimonial__slide--entering', 'rm-testimonial__slide--exiting', 'rm-testimonial__slide--from-next', 'rm-testimonial__slide--from-prev', 'rm-testimonial__slide--to-next', 'rm-testimonial__slide--to-prev');
        });
      };
      const show = (index, direction = 1) => {
        const nextIndex = (index + slides.length) % slides.length;
        if (nextIndex === activeIndex || isAnimating) return;
        if (reduceMotion.matches) {
          activeIndex = nextIndex;
          setVisibleSlide(activeIndex);
          return;
        }
        const currentSlide = slides[activeIndex];
        const nextSlide = slides[nextIndex];
        const fromClass = direction > 0 ? 'rm-testimonial__slide--from-next' : 'rm-testimonial__slide--from-prev';
        const toClass = direction > 0 ? 'rm-testimonial__slide--to-prev' : 'rm-testimonial__slide--to-next';
        isAnimating = true;
        nextSlide.hidden = false;
        nextSlide.classList.add('rm-testimonial__slide--entering', fromClass);
        currentSlide.classList.add('rm-testimonial__slide--exiting', toClass);
        window.requestAnimationFrame(() => nextSlide.classList.remove('rm-testimonial__slide--entering', fromClass));
        window.setTimeout(() => {
          currentSlide.hidden = true;
          currentSlide.classList.remove('rm-testimonial__slide--exiting', toClass);
          activeIndex = nextIndex;
          isAnimating = false;
        }, 280);
      };
      const prevHandler = () => show(activeIndex - 1, -1);
      const nextHandler = () => show(activeIndex + 1, 1);
      const keyHandler = (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        show(activeIndex + direction, direction);
      };
      previous.addEventListener('click', prevHandler);
      next.addEventListener('click', nextHandler);
      testimonial.addEventListener('keydown', keyHandler);
      setVisibleSlide(activeIndex);
      return () => {
        previous.removeEventListener('click', prevHandler);
        next.removeEventListener('click', nextHandler);
        testimonial.removeEventListener('keydown', keyHandler);
      };
    },
  });
})();
